<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px" v-text="sectionTitle"></h3>
      </v-toolbar>

      <v-flex xs12>
        <v-card tile class="pa-0 pt-2 mt-2 card-shadow">
          <v-card-title class="pb-1 pt-4">
            <span class="body-2">주제가 담긴 채널</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-list class="pt-0">
              <v-list-tile avatar v-for="(channel, index) of subjectChannels" :key="index" @click="$router.push({ name: 'Channel', params: { idx: channel.idx } })">
                <v-list-tile-avatar>
                  <v-img :src="channel.thumbnail ? `${$storage}/channel/${channel.thumbnail}` : thumbnailSrc"></v-img>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title class="display-2" v-text="channel.title"></v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action class="ml-2" style="flex-shrink: 0;">
                  <v-btn :dark="!channel.subscribes"
                         :outline="channel.subscribes"
                         :ripple="false"
                         round
                         depressed
                         color="primary"
                         class="ma-0 pa-0 button-subscribe"
                         @click.stop="subscribe(channel.idx)">
                    <v-icon :dark="!channel.subscribes"
                            size="16px">
                      {{ channel.subscribes ? '$vuetify.icons.confirm' : '$vuetify.icons.add' }}
                    </v-icon>
                    <div v-if="!channel.subscribes" class="button-subscribe-text ml-2">구독</div>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>

            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 class="pa-3">
        <v-layout row>
          <div style="flex-shrink: 0;">
            <span class="caption caption-strong" v-text="`${subjectPosts.length}개`"></span>
            <span class="caption" v-text="`의 컨텐츠가 있습니다.`"></span>
          </div>
          <v-spacer></v-spacer>
          <SortButton :initFilter.sync="filter" />
        </v-layout>
      </v-flex>

      <v-flex xs12 v-for="(post, index) of subjectPosts" :key="index" class="px-3">
        <FeedCard v-if="post.type === 'feed'"
                  :channelTitle="post.channels.title"
                  :channelIdx="post.channels.idx"
                  :idx="post.idx"
                  :contents="post.contents"
                  :hashtag="post.hashtag"
                  :imageList="post.image_list"
                  :userName="post.user.name"
                  :userProfileImage="post.user.profile_image"
                  :createdAt="post.created_at"
                  :likes="post.likes"
                  :likeCnt="post.like_cnt"
                  :bookmarks="post.bookmarks"
                  :bookmarkCnt="post.bookmark_cnt"
                  :commentCnt="post.comment_cnt"
                  @like="like(post.idx)"
                  @bookmark="bookmark(post.idx)" />
        <ContentCard v-else
                     :idx="post.idx"
                     :type="post.type"
                     :video_id="post.video_id"
                     :thumbnail="post.thumbnail"
                     :title="post.title"
                     :subtitle="post.subtitle"
                     :subtitle_color="post.subtitle_color" />
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import ContentCard from '@/components/ContentCard';
  import FeedCard from '@/components/FeedCard';
  import SortButton from '@/components/SortButton';
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'Topic',
    components: { FeedCard, ContentCard, SortButton },
    props: [ 'sectionIdx' ],
    computed: {
      ...mapGetters('home', [ 'subjectTitle', 'subjectChannels', 'subjectPosts' ]),
      thumbnailSrc () {
        return require('@/assets/img/profile-default.png');
      }
    },
    data () {
      return {
        filter: { name: '최신순' },
        // time: parseInt(new Date().getTime() / 1000),
        scrollY: 0,
        subjectIdx: this.$route.query.subjectIdx,
        sectionTitle: this.$route.query.sectionTitle,
      };
    },
    watch: {
      filter (filter) {
        if (filter.name === '인기순') {
          this.mutationSortSubjectPosts('popularity');
        } else {
          this.mutationSortSubjectPosts('latest');
        }
      }
    },
    created () {
      this.selectSubject({ sectionIdx: this.sectionIdx, subjectIdx: this.subjectIdx });
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    methods: {
      ...mapMutations('home', {
        mutateToggleSubscription: 'TOGGLE_SUBSCRIPTION',
        mutationToggleLike: 'TOGGLE_LIKE',
        mutationToggleBookmark: 'TOGGLE_BOOKMARK',
        mutationSortSubjectPosts: 'SORT_SUBJECT_POSTS',
      }),
      ...mapActions('home', [ 'selectSubject' ]),
      ...mapActions('channel', [ 'toggleSubscription' ]),
      ...mapActions('post', [ 'toggleLike', 'toggleBookmark' ]),
      getScrollY () {
        this.scrollY = window.scrollY;
      },
      subscribe (idx) {
        this.toggleSubscription(idx).then(response => {
          this.mutateToggleSubscription({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      like (idx) {
        this.toggleLike(idx).then(response => {
          this.mutationToggleLike({ idx, flag: response.data, location: 'subject' });
        }).catch(err => {
          console.error(err);
        });
      },
      bookmark (idx) {
        this.toggleBookmark(idx).then(response => {
          this.mutationToggleBookmark({ idx, flag: response.data, location: 'subject' });
        }).catch(err => {
          console.error(err);
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .button-subscribe {
    border-radius: 16px;
    min-width: 0;
    width: 76px;
    height: 32px;
    &-text {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: -0.3px;

      line-height: 14px;
      height: 16px;
    }
  }

  .caption {
    &-strong {
      font-weight: 700;
      color: map_get($colors, primary);
    }
    color: map_get($colors, brownish-grey);
  }

</style>
